import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, enum_type, bool_type, option_type, list_type, class_type, union_type, string_type, int32_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { News_BundeslandInfo_$reflection, Admin_AdminInfos$1_$reflection, News_AdminNews_$reflection, News_AdminNewsListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Paginated$1_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { State_$reflection } from "../../../fable_modules/Fulma.Elmish.1.0.0/DatePicker/Types.fs.js";
import { Remote$1, Remote$1_$reflection, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { DateFormField__get_IsValid, FormField__get_IsValid, DateValidationRule, DateFormField_Init_Z492D238E, ValidationRule, FormField_Init_Z1F39563A, DateFormField_$reflection, FormField_$reflection } from "../../../../Bfs.Web.Portale/Validation.fs.js";
import { empty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";

export class Page extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NewsList", "NewsEdit", "NewsNew"];
    }
}

export function Page_$reflection() {
    return union_type("AdminNews.Types.Page", [], Page, () => [[["page", int32_type]], [["id", string_type]], []]);
}

export class Filter extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Alle", "Pflege", "Therapie", "BfsPlus", "Jugendhilfe", "Kundennummer"];
    }
}

export function Filter_$reflection() {
    return union_type("AdminNews.Types.Filter", [], Filter, () => [[], [], [], [], [], [["Item", int32_type]]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadNewsPage", "NewsPageLoaded", "FilterChanged", "KundennummernFilterTextChanged", "FilterForKundennummer", "ActivateNews", "DeactivateNews", "ActiveChanged", "NewNews", "LoadNews", "NewsLoaded", "LoadAllKundennummern", "AllKundennummernLoaded", "LoadAllBundeslaender", "AllBundeslaenderLoaded", "ToggleBundesland", "ToggleAllBundeslaender", "TitelChanged", "TextChanged", "GueltigAbChanged", "AktivChanged", "KundenTypChanged", "KundennummernAddTextChanged", "AddKundennummer", "RemoveKundennummer", "DeleteImage", "UploadImage", "ImageUploaded", "Save", "Saved", "SavedNew", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("AdminNews.Types.Msg", [], Msg, () => [[["page", int32_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Paginated$1_$reflection(News_AdminNewsListItem_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Paginated$1_$reflection(News_AdminNewsListItem_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", Filter_$reflection()]], [["Item", string_type]], [], [["id", string_type]], [["id", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["id", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Admin_AdminInfos$1_$reflection(News_AdminNews_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Admin_AdminInfos$1_$reflection(News_AdminNews_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(int32_type), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(int32_type)]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(News_BundeslandInfo_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(News_BundeslandInfo_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", class_type("System.Guid")]], [], [["Item", string_type]], [["Item", string_type]], [["Item1", State_$reflection()], ["Item2", option_type(class_type("System.DateTime"))]], [["Item", bool_type]], [["Item", option_type(enum_type("Bfs.Web.Data.Service.Contracts.Kundenportal.KundenTyp", int32_type, [["Pflege", 1], ["Therapie", 2], ["BfsPlus", 4], ["Jugendhilfe", 5]]))]], [["Item", string_type]], [], [["Item", int32_type]], [], [["Item", class_type("Browser.Types.Blob", undefined)]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [bool_type, class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", bool_type]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("System.Guid"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("System.Guid")]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", GlobalMsg_$reflection()]]]);
}

export class Model extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ListModel", "ItemModel"];
    }
}

export function Model_$reflection() {
    return union_type("AdminNews.Types.Model", [], Model, () => [[["Item", NewsListModel_$reflection()]], [["Item", NewsModel_$reflection()]]]);
}

export class NewsListModel extends Record {
    constructor(PageNumber, Filter, News, AllKundennummern, KundennummernFilterText, KundennummernFilterEnabeld, AllBundeslaender) {
        super();
        this.PageNumber = (PageNumber | 0);
        this.Filter = Filter;
        this.News = News;
        this.AllKundennummern = AllKundennummern;
        this.KundennummernFilterText = KundennummernFilterText;
        this.KundennummernFilterEnabeld = KundennummernFilterEnabeld;
        this.AllBundeslaender = AllBundeslaender;
    }
}

export function NewsListModel_$reflection() {
    return record_type("AdminNews.Types.NewsListModel", [], NewsListModel, () => [["PageNumber", int32_type], ["Filter", Filter_$reflection()], ["News", Remote$1_$reflection(Paginated$1_$reflection(News_AdminNewsListItem_$reflection()))], ["AllKundennummern", list_type(int32_type)], ["KundennummernFilterText", string_type], ["KundennummernFilterEnabeld", bool_type], ["AllBundeslaender", list_type(News_BundeslandInfo_$reflection())]]);
}

export class NewsModel extends Record {
    constructor(Id, BackToPage, Titel, Text$, GueltigAb, Aktiv, KundenTyp, Kundennummern, HasImage, ImageUpdateTrigger, AllKundennummern, KundennummernAddText, KundennummernAddEnabeld, Bundeslaender, AllBundeslaender, IsDirty, Sending, TextAsHtml) {
        super();
        this.Id = Id;
        this.BackToPage = (BackToPage | 0);
        this.Titel = Titel;
        this.Text = Text$;
        this.GueltigAb = GueltigAb;
        this.Aktiv = Aktiv;
        this.KundenTyp = KundenTyp;
        this.Kundennummern = Kundennummern;
        this.HasImage = HasImage;
        this.ImageUpdateTrigger = (ImageUpdateTrigger | 0);
        this.AllKundennummern = AllKundennummern;
        this.KundennummernAddText = KundennummernAddText;
        this.KundennummernAddEnabeld = KundennummernAddEnabeld;
        this.Bundeslaender = Bundeslaender;
        this.AllBundeslaender = AllBundeslaender;
        this.IsDirty = IsDirty;
        this.Sending = Sending;
        this.TextAsHtml = TextAsHtml;
    }
}

export function NewsModel_$reflection() {
    return record_type("AdminNews.Types.NewsModel", [], NewsModel, () => [["Id", option_type(string_type)], ["BackToPage", int32_type], ["Titel", FormField_$reflection()], ["Text", FormField_$reflection()], ["GueltigAb", DateFormField_$reflection()], ["Aktiv", bool_type], ["KundenTyp", option_type(enum_type("Bfs.Web.Data.Service.Contracts.Kundenportal.KundenTyp", int32_type, [["Pflege", 1], ["Therapie", 2], ["BfsPlus", 4], ["Jugendhilfe", 5]]))], ["Kundennummern", list_type(int32_type)], ["HasImage", bool_type], ["ImageUpdateTrigger", int32_type], ["AllKundennummern", list_type(int32_type)], ["KundennummernAddText", string_type], ["KundennummernAddEnabeld", bool_type], ["Bundeslaender", list_type(class_type("System.Guid"))], ["AllBundeslaender", list_type(News_BundeslandInfo_$reflection())], ["IsDirty", bool_type], ["Sending", bool_type], ["TextAsHtml", string_type]]);
}

export function NewsListModel_Init(pagenumber, allKundennummern, allBundeslaender) {
    return new NewsListModel(pagenumber, new Filter(0, []), new Remote$1(1, []), allKundennummern, "", false, allBundeslaender);
}

export function NewsModel_Init(id, backToPage, allKundennummern, allBundeslaender) {
    return new NewsModel(id, backToPage, FormField_Init_Z1F39563A(new ValidationRule(2, [200])), FormField_Init_Z1F39563A(new ValidationRule(0, [])), DateFormField_Init_Z492D238E(new DateValidationRule(0, [])), true, undefined, empty(), false, 0, allKundennummern, "", false, empty(), allBundeslaender, false, false, "");
}

export function NewsModel__get_CanSubmit(x) {
    if ((!x.Sending && FormField__get_IsValid(x.Titel)) && FormField__get_IsValid(x.Text)) {
        return DateFormField__get_IsValid(x.GueltigAb);
    }
    else {
        return false;
    }
}

//# sourceMappingURL=Types.fs.js.map
